<template>
    <section v-if="!hideHistory() && getPriceHistory && getPriceHistory.length">
        <mvtCollapse :disable="disableCollapse" :isActive="isActive">
            <template v-slot:header="collapsible">
                <h2 v-if="!dpp.isRentals" class="f4 text-bold singleline">{{molang('dpp.propertyHistory.activeDppHistory', {streetAddress: dpp.geo.address})}}</h2>
                <h2 v-else class="f4 text-bold singleline">{{molang('dpp.propertyHistory.history')}}</h2>
                <div class="f7 text-gray singleline" v-show="collapsible.collapsed">{{ description }}</div>
            </template>
            <template v-slot:default>
                <ul class="property-history">
                    <template v-for="item in historyData" :key="item.dateMonthYear">
                        <li class="title">
                            <b>{{ item.dateMonthYear }} </b>
                            <div v-if="!item?.history?.[0].isRental">
                                <img v-if="mlsLogoSrc(item?.history?.[0].mlsId) && shouldShowHistoryLogo()" alt="mls logo" loading="lazy" :src="mlsLogoSrc(item?.history?.[0].mlsId)" />
                                <span class="text-gray" v-if="!dpp.showAsPR">MLS # {{ item?.history?.[0].mlsNumber }}</span>
                            </div>
                        </li>
                        <li class="desc" v-for="record in item.history" :key="record.dateDesktop">
                            <span>{{ record.dateDesktop || '—' }}</span>
                            <span>{{ record.status }}</span>
                            <template v-if="record.status === 'Sold' && dpp.hidePropertyPrice">—</template>
                            <template v-else>
                                <div>
                                    <span>{{ record.priceDesktop || '—' }}<template v-if="record.isRental">/Mo</template></span>
                                    <span :class="getClass(record.priceChangeTag)" v-if="record.change != '—'">({{ record.change }})</span>
                                </div>
                            </template>
                        </li>
                    </template>
                </ul>
                <dppCtaCard
                    v-if="dpp.isActive"
                    :dppCtaInfo="{
                        title: molang('dpp.propertyHistory.ctaTitle'),
                        sub: molang('dpp.propertyHistory.ctaSub'),
                        cta: molang('dpp.sellbanner.connectNow'),
                        icon: 'icon-open-house',
                        hotleadType: 'PropertyHistoryDPP',
                        section: 'Property History',
                    }"
                />
                <div class="paragraph f7" v-if="showNotSupportedByMLS()">
                    {{ molang('dpp.movotoPowered') }}
                </div>
            </template>
        </mvtCollapse>
    </section>
</template>
<script src="./property-history.js"></script>

<style lang="scss">
@use './property-history.scss' as *;
</style>
